import React, { useEffect, useState } from 'react';
import { DefaultOptionType } from 'rc-select/lib/Select'

import { FormElementChangeEvent } from '.';

import AutoComplete, { AutoCompleteProps } from './auto-complete';

const isValueInOptions = (value: any, options?: any[]) => {
  return options?.some(i => i.label === value || i.value === value);
};

const filterOption = (input: string, option: DefaultOptionType | undefined) =>
    (option?.label as string)?.toLocaleLowerCase()?.includes(input.toLocaleLowerCase())

const DropdownAutoComplete: React.FC<AutoCompleteProps> = props => {
  const { onChange, onBlur, value: valueProp, onSearch, ...rest } = props;

  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(valueProp as string);
  }, [valueProp, setValue]);

  const handleSelect = ({ name, value }: any) => {
    onChange && onChange({ name, value });
  };

  const handleChange = ({ value }: FormElementChangeEvent) => {
    setValue(value);
  };

  const handleBlur = (event: FormElementChangeEvent) => {
    onBlur && onBlur(event);
    if (!isValueInOptions(value, rest.options)) {
      onChange && onChange({ value: '', name: event.name });
      setValue('');
    }
  };

  return (
    <AutoComplete
      {...rest}
      value={value}
      filterOption={filterOption}
      onBlur={handleBlur}
      onSelect={handleSelect}
      onChange={handleChange}
      onSearch={onSearch}
    />
  );
};

export default DropdownAutoComplete;
